module.exports = __webpack_public_path__ + "img/br29.3c7b183.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br29.jpg
// module id = buH/
// module chunks = 0